<template>
  <div class="tender-general-information">
    <div class="tender-general-information__main-content">
      <div class="tender-general-information__left">
        <div class="title">{{ $t('tender-details.information') }}</div>
        <div v-if="tender.published" class="tender-general-information__published-date">
          <div class="subtitle">{{ $t('tender-details.informations.published-date') }}</div>
          <div class="tender-general-information__value">{{ tender.published }}</div>
        </div>

        <div v-if="tender.closingDate" class="tender-general-information__closing-date">
          <div class="subtitle">{{ $t('tender-details.informations.closing-date') }}</div>
          <div class="tender-general-information__value">
            <span
              v-tooltip="{
                content: tender.closingDateDetails,
                trigger: isMobile ? 'click' : 'focus hover',
              }"
              :class="{ 'underline-accent': tender.closingDate !== '-' }"
            >
              <span>{{ tender.closingDate }}</span>
            </span>
          </div>
          <div v-if="tender.value">
            <div class="subtitle">{{ $t('tender-details.informations.value') }}</div>
            <div class="tender-general-information__value">
              <span v-if="tender.minValue" class="number-monospace">
                >{{ formatNumToCurrency(tender.minValue.amount) }} {{ $t('basic-words.to') }}
              </span>
              <span class="number-monospace">{{ formatNumToCurrency(tender.value.amount) }}</span>
              <span>({{ tender.value.currency }})</span>
            </div>
          </div>
        </div>

        <div v-if="deliveryLocations.length" class="tender-general-information__delivery-area">
          <div class="subtitle">{{ $t('tender-details.informations.delivery-area') }}</div>
          <div v-for="(location, index) in deliveryLocations" :key="index" class="tender-general-information__value">
            <span
              v-tooltip="{ content: location.raw, trigger: isMobile ? 'click' : 'focus hover' }"
              :class="{ 'underline-accent': location.raw }"
              >{{ formatDeliveryLocation(location) }}</span
            >
          </div>
        </div>

        <div v-if="tender.tenderers" class="tender-general-information__tenderers">
          <div class="subtitle">{{ $t('tender-details.informations.tenderers') }}</div>
          <div class="tender-general-information__value">{{ tender.tenderers }}</div>
        </div>

        <div v-if="tender.procurementCategory" class="tender-general-information__contract-type">
          <div class="subtitle">{{ $t('tender-details.informations.contract-type') }}</div>
          <div class="tender-general-information__value">
            {{ $t(`search-filters.contract-type.values.${tender.procurementCategory}`) }}
          </div>
        </div>

        <div v-if="tender.procurementMethod" class="tender-general-information__tender-method">
          <div class="subtitle">{{ $t('tender-details.informations.procurement-method') }}</div>
          <div class="tender-general-information__value">
            {{ $t(`tender-details.procurement-methods.${tender.procurementMethod}`) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumToCurrency } from '@/util/currency-util';
import IsMobileMixin from '@/mixins/is-mobile-mixin';
import { formatDeliveryLocation, getEffectiveDeliveryLocations } from '@/util/delivery-location-display';

export default {
  name: 'TenderGeneralInformation',
  mixins: [IsMobileMixin],
  props: {
    tender: {
      type: Object,
      required: true,
      default: () => {},
    },
    onlyProperty: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    deliveryLocations() {
      return getEffectiveDeliveryLocations(this.tender);
    },
  },
  methods: {
    formatNumToCurrency,
    formatDeliveryLocation(location) {
      return formatDeliveryLocation(
        location,
        (key) => this.$t(key),
        (key) => this.$te(key),
      );
    },
  },
};
</script>

<style lang="scss">
.tender-general-information {
  display: flex;
  min-width: 35%;

  &__main-content {
    display: flex;
    width: 100%;
  }

  &__value {
    color: $color-normal-pale;
    font-size: $font-size-small;
    line-height: 1.43;
    list-style-type: none;
    word-break: break-word;
  }
}

.underline-accent {
  display: inline-flex;
  cursor: help;
}
</style>
